<template>
  <app-chart-wrapper :data-grid-area="name">

    <div class="statistic-card-body">

      <h5 class="heading">
        {{heading}}
        <i class="mdi mdi-help-circle-outline pointer"
           v-if="tooltip"
           v-tooltip="tooltip"></i>
      </h5>

      <Loading v-if="loading" />

      <div v-else
           class="number">
        {{data}}{{dataAttachment}}
      </div>

    </div>

  </app-chart-wrapper>
</template>

<script>
import Loading from "@/components/generic/Loading.vue";
import loadsOnFilterUpdate from "@mixins/loads-on-filter-update";
import AppChartWrapper from "@components/chart/ChartWrapper";
import chartProps from "@components/chart/mixins/chartProps";

export default {
  components: {
    AppChartWrapper,
    Loading,
  },

  props: {
    // dataLoader: {
    //     type: String,
    //     required: true,
    // },

    dataAttachment: {
      type: String,
      required: true,
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    data() {
      return this.$store.state.statistics[this.name];
    },

    filters() {
      return this.$store.state.statistics.filters;
    },
  },

  methods: {
    load() {
      //this.$loader.statistics[this.dataLoader](this.filters)
    },
  },

  mixins: [loadsOnFilterUpdate, chartProps],
};
</script>

<style lang="scss" scoped>
.statistic-card-body {
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;

  .number {
    margin: auto;
    font-weight: 600;
    letter-spacing: 4px;
    font-size: 54px;
  }

  @media screen and (max-width: 1700px) {
    .heading {
      font-size: 15px;
      height: 33px;
      white-space: normal;
      text-align: center;
    }

    .number {
      font-size: 44px;
    }
  }

  @media screen and (max-width: 1400px) {
    .heading {
      font-size: 14px;
    }

    .number {
      font-size: 34px;
    }
  }
}
</style>
